import { useParams } from "react-router-dom";
import EditMeetingRequest from "./EditMeetingRequest";
import { useGetMeetingRequestByIdQuery } from "../../../../reactQueries/AppApi/rqHooksForMeetingRequests";
import MpgErrorDialog from "../../../../common/dialog/MpgErrorDialog";

const EditMeetingRequestHome = () => {
  let { Id } = useParams();

  /**API calls */
  const {
    isSuccess,
    isLoading,
    isFetching,
    error,
    data: meetingDataById,
    isError,
  } = useGetMeetingRequestByIdQuery({ Id });

  console.log("i am edit")

  return (
    <div>
      {(!!isFetching) && "Wait, Loading..."}

      {!!isSuccess && (<EditMeetingRequest meetingDataById={meetingDataById} />)}

      <MpgErrorDialog
        open={!!isError}
      />
    </div>
  );
};
export default EditMeetingRequestHome;
